export const WIZARD_PAGE_LOADER_ERROR_ID = 'wizard-page-loader-error';
